import { PartnerClientManager } from 'types/partnerClientManagerTypes';
import { createClient } from 'utils/clientUtils';

export const createPartnerClientManager = (): PartnerClientManager => ({
  opened: false,
  clientId: 0,
  client: createClient(),
  organizationName: '',
  monthReports: [],
  clientInvalidated: false,
  notesText: '',
  notesTextInvalidated: false,
  monthReportsInvalidated: false,
});
